import React, { PureComponent } from 'react';
import classNames from 'classnames';
import Svg from 'rp-react-svg-icon';
import PropTypes from 'prop-types';

import DamDetails from './DamDetails';
import StallionDetails from './StallionDetails';
import GenericDetails from './GenericDetails';
import { getHorseType } from '../../utils/horse';

const stallionKeys = ['trainerUid', 'ownerUid', 'sireComment'];
const genericKeys = ['sireUid', 'damUid', 'damSireUid'];
const requiredKeys = [
    'horseDateOfBirth',
    'horseSexCode',
    'breederName',
    ...genericKeys,
    ...stallionKeys,
];

const isExtraDataPresent = (data, isSire) => (isSire ? stallionKeys : genericKeys)
    .every(key => data[key]);

const getTypeSpecificDetails = (props, type, isMobile = false) => {
    if (type === 'sire') {
        return <StallionDetails {...props} isMobile={isMobile} />;
    }

    if (type === 'dam') {
        return <DamDetails {...props} />;
    }

    return <GenericDetails {...props} />;
};

class Details extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            expanded: false,
        };
        this.isEmpty = requiredKeys.every(key => !props[key]);
        const type = getHorseType(props);
        this.isExtraDataPresent = isExtraDataPresent(props, type === 'sire');
    }

    toggleDetails = () => {
        this.setState(state => ({ expanded: !state.expanded }));
    }

    render() {
        const type = getHorseType(this.props);
        const { isMobile } = this.props;

        return this.isEmpty ? null : (
            <div
                className={classNames(
                    'hp-details',
                    this.state.expanded && 'hp-details__expanded'
                )}
            >
                {getTypeSpecificDetails(this.props, type, isMobile)}
                {this.isExtraDataPresent && (
                    <button
                        className="ui-btn hidden-md-up hp-details__expandBtn"
                        onClick={this.toggleDetails}
                    >
                        <Svg iconName="down" size="Medium" />
                    </button>
                )}
            </div>
        );
    }
}

Details.propTypes = {
    isMobile: PropTypes.bool,
};

export default Details;



// WEBPACK FOOTER //
// ./src/js/horse/details/Details.jsx